import React from "react";
import { GoogleAdSlot } from "./GoogleAdSlot";

export function InFeedSponsored() {
  return (
    <div className="my-4 card overflow-hidden relative" data-testid="in-feed-sponsored">
      <GoogleAdSlot
        slot="2010205338"
        mobileMinHeight={56}
        desktopMinHeight={130}
        testId="adsense-feed-banner"
      />
    </div>
  );
}
